export default __webpack_public_path__ + "static/media/salt-bnb.934bd3b8.png";